import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import website from '@/config/website';
import { modelList, removeModel, deployModel } from "@/api/flow/flow";
import { flowCategory } from "@/util/flow";
export default {
  data: function data() {
    return {
      form: {},
      optionDeploy: {
        menuBtn: false,
        column: [{
          label: "流程类型",
          type: "select",
          dicUrl: "/api/blade-system/dict/dictionary?code=flow",
          props: {
            label: "dictValue",
            value: "dictKey"
          },
          dataType: "number",
          slot: true,
          prop: "categoryValue",
          search: true,
          span: 24,
          rules: [{
            required: true,
            message: "请选择流程类型",
            trigger: "blur"
          }]
        }, {
          label: "流程模式",
          prop: "flowMode",
          type: "radio",
          dicData: [{
            label: "通用流程",
            value: 1
          }, {
            label: "定制流程",
            value: 2
          }],
          value: 1,
          span: 24,
          rules: [{
            required: true,
            message: '请选择流程模式',
            trigger: 'blur'
          }]
        }, {
          label: "所属租户",
          prop: "tenantId",
          type: "tree",
          multiple: true,
          dicUrl: "/api/blade-system/tenant/select",
          props: {
            label: "tenantName",
            value: "tenantId"
          },
          display: false,
          span: 24,
          rules: [{
            required: true,
            message: '请选择所属租户',
            trigger: 'blur'
          }]
        }]
      },
      selectionId: '',
      selectionList: [],
      query: {},
      loading: true,
      deployLoading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      deployBox: false,
      flowBox: false,
      flowUrl: '',
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        selection: true,
        editBtn: false,
        addBtn: false,
        viewBtn: false,
        delBtn: false,
        dialogWidth: 900,
        menuWidth: 150,
        dialogClickModal: false,
        column: [{
          label: '模型主键',
          prop: 'id'
        }, {
          label: '模型标识',
          prop: 'modelKey',
          search: true,
          width: 150
        }, {
          label: '模型名称',
          prop: 'name',
          search: true,
          width: 150
        }, {
          label: '流程版本',
          prop: 'version',
          slot: true,
          width: 80
        }, {
          label: '创建时间',
          prop: 'created',
          width: 165
        }, {
          label: '更新时间',
          prop: 'lastUpdated',
          width: 165
        }]
      },
      data: []
    };
  },
  watch: {
    'form.flowMode': function formFlowMode() {
      var _this = this;

      this.$refs.form.option.column.filter(function (item) {
        if (item.prop === "tenantId") {
          item.display = _this.form.flowMode === 2;
        }
      });
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["permission"])), {}, {
    ids: function ids() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  }),
  methods: {
    handleSubmit: function handleSubmit(form, done) {
      var _this2 = this;

      this.deployLoading = true;
      deployModel({
        modelId: this.selectionId,
        category: flowCategory(form.categoryValue),
        tenantIds: form.tenantId.join(",")
      }).then(function (res) {
        var data = res.data;

        if (data.success) {
          _this2.$message({
            type: "success",
            message: data.msg
          });

          done();

          _this2.$refs.form.resetForm();

          _this2.deployBox = false;
          _this2.deployLoading = false;
        } else {
          done();
          _this2.deployLoading = false;

          _this2.$message({
            type: "warn",
            message: data.msg
          });
        }
      });
    },
    searchReset: function searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange: function searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange: function selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear: function selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete: function handleDelete() {
      var _this3 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return removeModel(_this3.ids);
      }).then(function () {
        _this3.$message({
          type: "success",
          message: "操作成功!"
        });

        _this3.$refs.crud.toggleSelection();

        _this3.onLoad(_this3.page);
      });
    },
    handleCreate: function handleCreate() {
      this.flowUrl = "".concat(website.flowDesignUrl, "/index.html");
      this.flowBox = true;
    },
    handleUpdate: function handleUpdate(row) {
      this.flowUrl = "".concat(website.flowDesignUrl, "/index.html#/editor/").concat(row.id);
      this.flowBox = true;
    },
    handleDeploy: function handleDeploy(row) {
      this.deployBox = true;
      this.selectionId = row.id;
    },
    handleDoDeploy: function handleDoDeploy() {
      this.$refs.form.submit();
    },
    handleDownload: function handleDownload(row) {
      window.open("".concat(website.flowDesignUrl, "/app/rest/models/").concat(row.id, "/bpmn20"));
    },
    handleSlotDelete: function handleSlotDelete(row) {
      var _this4 = this;

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return removeModel(row.id);
      }).then(function () {
        _this4.$message({
          type: "success",
          message: "操作成功!"
        });

        _this4.$refs.crud.toggleSelection();

        _this4.onLoad(_this4.page);
      });
    },
    handleRefresh: function handleRefresh() {
      this.flowBox = false;
      this.onLoad(this.page);
    },
    currentChange: function currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange: function sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange: function refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad: function onLoad(page) {
      var _this5 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.loading = true;
      modelList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(function (res) {
        var data = res.data.data;
        _this5.page.total = data.total;
        _this5.data = data.records;
        _this5.loading = false;

        _this5.selectionClear();
      });
    }
  }
};